import { deleteTagItem, getTags, postTag, postTagItem } from './api'

export const fetchTags = async (query) => {
  const response = await getTags(query)

  return {
    type: 'FETCH_TAGS_SUCCESS',
    data: response
  }
}

export const createTag = async (tag) => {
  const response = await postTag(tag)

  return {
    type: 'CREATE_TAG_SUCCESS',
    data: response
  }
}

export const assignTag = async (tag) => {
  const response = await postTagItem(tag)

  return {
    type: 'ASSIGN_TAG_SUCCESS',
    data: response
  }
}

export const removeTag = async (tag) => {
  const response = await deleteTagItem(tag)

  return {
    type: 'REMOVE_TAG_SUCCESS',
    data: response
  }
}
